import { createContext } from 'react';

interface DrawerOverrides {
  showBackButton?: boolean;
  setShowBackButton?: React.Dispatch<React.SetStateAction<boolean | undefined>>;

  backButtonAction?: () => void;
  setBackButtonAction?: React.Dispatch<
    React.SetStateAction<() => void> | undefined
  >;
}

export const DrawerOverridesContext = createContext<DrawerOverrides>({});
